import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";

import {
  DeleteCommunityEntityMutationMutation,
  DeleteCommunityEntityMutationMutationVariables
} from "../../../../schemaTypes";

import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

export const deleteCommunityEntityMutation = gql`
  mutation DeleteCommunityEntityMutation($id: String!) {
    deleteCommunityEntity(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: DeleteCommunityEntityMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const DeleteCommunityEntity: React.FC<Props> = ({ children, onMessage }) => {
  const [deleteCommunityEntity, { loading, error }] = useMutation<
    DeleteCommunityEntityMutationMutation,
    DeleteCommunityEntityMutationMutationVariables
  >(deleteCommunityEntityMutation);

  const submit = async (
    values: DeleteCommunityEntityMutationMutationVariables
  ) => {
    const { data } = await deleteCommunityEntity({
      variables: values,
    });

    const errors = data?.deleteCommunityEntity?.errors
      ? normalizeErrors(data.deleteCommunityEntity.errors)
      : null;

    if (data?.deleteCommunityEntity?.message && onMessage) {
      onMessage(data.deleteCommunityEntity.message);
    }

    return {
      errors,
      message: data?.deleteCommunityEntity?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
